<template>
<el-dialog :title="viewFlag ? '查看' : !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="80%" :visible.sync="viewData.visible">
    <!-- <H1 style="text-align:center">北京汽车制造厂（青岛）有限公司</H1> -->
    <div style="margin-bottom: 30px;">
        供应商：{{decidedSupplier}}
    </div>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" size="mini" class="org-dialog-form">
        <el-tabs v-model="activeName">
            <el-tab-pane class="tab_style" :key="1" name="BasicInfo" :label="`基本信息`">
                <div class="des_box">
                    <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                        <el-descriptions-item label="询价单编码:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="quotationCode" style="margin-bottom: 0;">
                                {{dataForm.rfqCode}}
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="项目名称:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="projectName" style="margin-bottom: 0;">
                                {{dataForm.projectName}}
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="任务单号:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="projectName" style="margin-bottom: 0;">
                                {{dataForm.taskCode}}
                            </el-form-item>
                        </el-descriptions-item>
                        <!-- <el-descriptions-item label="税码:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="supportingPartner" style="margin-bottom: 0;">
                                {{dataForm.feeCode}}
                            </el-form-item>
                        </el-descriptions-item> -->
                        <!-- <el-descriptions-item label="技术通知编码:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="projectName" style="margin-bottom: 0;">
                                {{dataForm.techCode}}
                            </el-form-item>
                        </el-descriptions-item> -->
                        <!-- <el-col :span="8">
                                <el-form-item label="提交人" prop="projectName">
                                    {{dataForm.submitor}}
                                </el-form-item>
                            </el-col> -->

                        <el-descriptions-item label="询价创建时间:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="rfqCreateTime" style="margin-bottom: 0;">
                                {{dateFormatValue(dataForm.rfqCreateTime)}}
                            </el-form-item>
                        </el-descriptions-item>
                        <!-- <el-descriptions-item label="询价截止时间:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="rfqStopTime" style="margin-bottom: 0;">
                                {{dateFormatValue(dataForm.rfqStopTime)}}
                            </el-form-item>
                        </el-descriptions-item> -->
                        <el-descriptions-item label="报价截止时间:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="quotationStopTime" style="margin-bottom: 0;">
                                {{dateFormatValue(dataForm.quotationStopTime)}}
                            </el-form-item>
                        </el-descriptions-item>
                        <!-- <el-descriptions-item label="询价状态:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="projectName" style="margin-bottom: 0;">
                                {{dataForm.quotationStatus}}
                            </el-form-item>
                        </el-descriptions-item> -->
                        <el-descriptions-item label="报价状态:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="rfqSupplierReplyStatus" style="margin-bottom: 0;">
                                {{getRfqSupplierReplyStatus(dataForm.rfqSupplierReplyStatus)}}
                            </el-form-item>
                        </el-descriptions-item>
                        <!-- <el-descriptions-item label="延期次数:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="projectName" style="margin-bottom: 0;">
                                {{dataForm.delayTimes}}
                            </el-form-item>
                        </el-descriptions-item> -->
                        <el-descriptions-item label="轮次:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="projectName" style="margin-bottom: 0;">
                                {{dataForm.times}}
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购负责人:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="supportingPartner" style="margin-bottom: 0;">
                                {{dataForm.supplyResponsor}}
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="技术负责人:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="supportingPartner" style="margin-bottom: 0;">
                                {{dataForm.techResponsor}}
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="质量负责人:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="supportingPartner" style="margin-bottom: 0;">
                                {{dataForm.qualityResponsor}}
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </el-tab-pane>
            <el-tab-pane class="tab_style" :key="3" name="PurchaseInfo" :label="`采购清单`">
                <el-row :gutter="10">
                    <el-col :span="24">
                        <span>采购清单</span>
                        <!-- <el-button v-if="dataForm.rfqStatus === QUOTATION_STATUS.QUOTAIONSTART && userInfo.typeId !== USER_TYPE.SUPPLIER" style="float:right" size=mini @click="addOrUpdateVotedSupplierHandle()">保存</el-button> -->
                        <el-table :data="partList" row-key="id" size="small" :header-cell-style="{background:'#f5f5f5'}" border style="width: 100%;" :default-expand-all="false">
                            <el-table-column type="index" width="50" label="序号">
                            </el-table-column>
                            <el-table-column prop="partCode" header-align="left" align="left" label="零件编号">
                            </el-table-column>
                            <el-table-column prop="partName" header-align="left" align="left" label="零件名称">
                            </el-table-column>
                            <el-table-column prop="oneCarCount" header-align="center" align="right" label="单车用量">
                            </el-table-column>
                            <el-table-column prop="supplyStatus" header-align="center" align="center" label="供货状态" width="80">
                                <template slot-scope="scope">
                                    <span>{{supplyStatusFormat(scope.row.supplyStatus)}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <!--            v-if="dataForm.quotationStatus === QUOTATION_STATUS.JOINED || dataForm.quotationStatus === QUOTATION_STATUS.COMMITED" -->
            <el-tab-pane class="tab_style" :key="2" v-if="dataForm.rfqStatus !== RFQ_STATUS.BEFORE_ASK" name="QuotationInfo" :label="`报价表`">
                <part-price-tab ref="partPriceTab" :vender="vender" :dataForm="dataForm"></part-price-tab>
            </el-tab-pane>
            <el-tab-pane class="tab_style" name="附件文件" label="附件文件">
                <!-- 上传下载 产看 需求文档 -->
                <el-row :gutter="10">
                    <el-col :span="24">
                        <FileUpDown ref="FileUpDown" :bizId="dataForm.rfqSupplierId" :bizType="FILE_BIZ_TYPE"></FileUpDown>
                    </el-col>
                </el-row>
            </el-tab-pane>
        </el-tabs>
        <el-row :gutter="40" v-if="!viewFlag">
            <el-col :span="24" style="text-align:right;">
                <el-button size="mini" @click="viewData.visible = false">
                    取消
                </el-button>
                <!-- 询价中 -->
                <el-tooltip v-if="!viewFlag && dataForm.rfqStatus === RFQ_STATUS.BEFORE_ASK && rowData.rfqSupplierReplyStatus == QUOTATION_STATUS.BEGIN" class="item" effect="dark" content="供应商点击参与报价" placement="top">
                    <el-button size="small" type="success" plain title="供应商点击参与报价" @click="joinSubmit()">
                        参与报价
                    </el-button>
                </el-tooltip>
                <el-tooltip v-if="!viewFlag && dataForm.rfqStatus === RFQ_STATUS.BEFORE_ASK && rowData.rfqSupplierReplyStatus == QUOTATION_STATUS.BEGIN" class="item" effect="dark" content="供应商点击发布询价" placement="top">
                    <el-button size="small" type="danger" plain @click="giveupSubmit()">
                        弃权
                   </el-button>
                </el-tooltip>
                <!-- 供应商保存 -->
                <el-button v-if="!viewFlag && (dataForm.rfqStatus === RFQ_STATUS.BEFORE_ASK)" size="small" type="primary" plain @click="saveQuotation()">
                    保存
                </el-button>
                <!-- 供应商提交报价 -->
                <el-button v-if="!viewFlag && (dataForm.rfqStatus === RFQ_STATUS.ASKING)" size="small" type="success" plain @click="submitQuotation()">
                    提交报价
                </el-button>
            </el-col>
        </el-row>
    </el-form>
    <!-- 弹窗, 新增 / 修改 -->
    <!-- <addOrUpdate v-if="addOrUpdateQuotedPriceVisibe" ref="addOrUpdate" @refreshDataList="getAppartmentList"></addOrUpdate> -->
</el-dialog>
</template>

<script>
import {
    getQuotationDetail,
    editQuotation,
    createQuotation,
    getRfqPartsByVenderId
} from '@/controller/quotation'
// import {
//     getRfqSupplierByVenderId
// } from '@/controller/rfq'
import {
    USER_TYPE,
    RFQ_STATUS,
    QUOTATION_STATUS,
    QUOTATION_STATUS_VALUE,
    SUPPLY_STATUS,
    getLabelByValue,
} from '@/utils/const'
import moment from 'moment'
import {
    copy
} from '@/utils'
// import AddOrUpdate from './quotation-part-add-or-update'
import PartPriceTab from './quotation-part-price-tab'
import FileUpDown from "@/views/common/file-up-down";
export default {
    components: {
        // AddOrUpdate,
        PartPriceTab,
        FileUpDown
    },
    props: {
        vender: Object,
    },
    data() {
        return {
            FILE_BIZ_TYPE: 13,
            // addOrUpdateQuotedPriceVisibe: false,
            rowData: null,
            viewFlag: false,
            tableData: [],
            activeName: 'BasicInfo',
            RFQ_STATUS: RFQ_STATUS,
            QUOTATION_STATUS: QUOTATION_STATUS,
            viewData: {
                visible: false,
                width: ''
            },
            dataList: [],
            supplierList: [],
            partList: [],
            rfqSupplierReplyStatus: '',
            userInfo: '',
            USER_TYPE: USER_TYPE,
            decidedSupplier: '',
            dataForm: {
                rfqSupplierReplyStatus: '',
                id: 0,
                name: '',
                code: '',
                parentId: '',
                parentName: '',
                mwskz : '',
                parentNodePath: '',
                tenantId: '',
                tenantName: '',
                projectId: '',
                projectName: '',
                projectCode: '',
                technicalCode: '',
                taskCode: '',
                rfqCode: '',
                feeCode: '',
                submitor: '',
                rfqCreateTime: '',
                rfqStopTime: '',
                quotationStopTime: '',
                rfqStatus: '',
                quotationStatus: '',
                delayTimes: 0,
                times: 0,
                supplyResponsor: '',
                techResponsor: '',
                qualityResponsor: '',
                carType: '',
                deleteFlag: 0,
                lastFlag: 0,
                rfqSupplierId: '',
                venderId:''
            },
            dataRule: {}
        }
    },
    mounted() {},
    methods: {
        init(data, id, viewFlag) {
            this.activeName = "BasicInfo"
            this.rowData = Object.assign({}, data);
            this.viewFlag = viewFlag
            if (!this.dataForm.quotationStatus) this.dataForm.quotationStatus = 1
            this.userInfo = this.$store.state.user.userInfo
            // this.dataForm = data ? data : this.data
            // this.dataForm = copy(this.dataForm)
            this.dataForm.id = this.rowData.id || 0
            this.viewData.visible = true
            this.$nextTick(() => {
                //初始化上传附件
                this.$refs.FileUpDown.init(this.viewFlag);
                // this.$refs['dataForm'].resetFields()
                // this.dataForm.tenantName = sessionStorage.getItem('tenantName')
                if (this.dataForm && this.dataForm.id) {
                    // getQuotationDetail({}, this.dataForm.id).then(data => {
                    //     console.log(data)
                    //     if (data && data.code === '00') {
                    //         this.dataForm = data.body
                    //     }
                    // })
                    this.dataForm = this.rowData;
                    // 获取供应商状态
                    // this.getSupplierByVenderId()
                    this.decidedSupplier = this.vender.venderName;
                    console.log('this.dataForm.priceBit',this.dataForm.priceBit)
                    this.$refs.partPriceTab.getAppartmentList(this.viewFlag,this.dataForm.times,this.dataForm.priceBit)
                    this.getAppartmentList()
                }
            })
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD前")
        },
        dateFormatValue: function (value) {
            if (!value) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        // 查所有询价零件
        getAppartmentList() {
            getRfqPartsByVenderId({
                id: this.dataForm.id,
                venderId: this.rowData.venderId
            }).then((data) => {
                if (data && data.code === "00") {
                    this.partList = data.body;
                } else {
                    this.partList = [];
                }
            });
        },
        // 查所有供应商表
        // getCurrentSupplierStatus() {
        //     getRfqSupplierByVenderId({
        //         userId: this.userInfo.id,
        //     }).then((data) => {
        //         if (data && data.code === "00") {
        //             this.rfqSupplierReplyStatus = data.body.rfqSupplierReplyStatus;
        //         } else {
        //             this.supplierList = [];
        //         }
        //     });
        // },
        handleTabClick(tab, event) {
            console.log(tab, event);
            this.getAppartmentList(tab.name)
        },
        // 供应商采购员保存报价
        saveQuotation() {
            // TODO: 每个供应商填写报价六张表
            // 附件文件上传
            this.dataFormSubmit('保存报价成功')
        },
        joinSubmit() {
            // 更新供应商报价状态
            this.dataForm.quotationStatus = QUOTATION_STATUS.JOINED
            this.rowData.rfqSupplierReplyStatus = QUOTATION_STATUS.JOINED;
            // 更新供应商列表里的参与
            this.dataFormSubmit('参与成功')
        },
        giveupSubmit() {
            // 更新供应商报价状态
            this.dataForm.quotationStatus = QUOTATION_STATUS.REJECT
            this.rowData.rfqSupplierReplyStatus = QUOTATION_STATUS.REJECT;
            // 更新供应商列表里的状态放弃
            this.dataFormSubmit('已弃权')
        },
        // 供应商提交报价
        submitQuotation() {
            // 整个都是报价中吗？
            // TODO: 每个供应商填写报价六张表
            // 附件文件上传
            // 供应商上传价格确认书
            // 更新供应商报价状态
            for (let i = 0; i < this.$refs.partPriceTab.partList.length; i++) {
                if (!this.$refs.partPriceTab.partList[i].id) {
                    this.$message.error("您还有零件未报价，不能提交报价")
                    return;
                }
            }

            this.dataForm.quotationStatus = QUOTATION_STATUS.COMMITED
            this.dataFormSubmit('提交报价成功')
        },
        // 表单提交
        dataFormSubmit(msg) {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    let params = copy(this.dataForm)
                    console.log(params)
                    if (this.dataForm.id) {
                        params['venderId'] = this.rowData.venderId;
                        editQuotation(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: msg,
                                    type: 'success',
                                    onClose: () => {
                                        // this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createQuotation(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: msg,
                                    type: 'success',
                                    onClose: () => {
                                        // this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        supplyStatusFormat: function (value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(SUPPLY_STATUS, value);
        },
        getRfqSupplierReplyStatus: function (value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(QUOTATION_STATUS_VALUE, value);
        },
        // // 新增 / 修改 报价
        // addOrUpdateHandle(row) {
        //     this.addOrUpdateQuotedPriceVisibe = true;
        //     row.rfqId = this.dataForm.id
        //     this.$nextTick(() => {
        //         this.$refs.addOrUpdate.init(row, this.vender);
        //     });
        // },
        // showHandle(row) {
        //     this.addOrUpdateQuotedPriceVisibe = true;
        //     row.rfqId = this.dataForm.id
        //     this.$nextTick(() => {
        //         this.$refs.addOrUpdate.init(row, this.vender, 'view');
        //     });
        // },
        getStyle() {
            return 'width: 110px; text-align: right'
        },
        getStyle2() {
            // return 'width: 455.5px;'
        }
    }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}

.button-danger {
    color: #F56C6C
}

.mb15 {
    margin-bottom: 15px;
}

.tab_style {
    min-height: 35vh;
}
</style>
